// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class CopyToClipboard extends WebComponent {
  constructor(props) {
    super(props);
    this.handleLinkClick = this.handleLinkClick.bind(this);
  }

  didMount() {
    this.element.addEventListener('click', this.handleLinkClick);
  }

  showToast(message) {
    const toast = document.createElement('div');
    toast.textContent = message;
    toast.style.position = 'fixed';
    toast.style.bottom = '32px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%)';
    toast.style.background = 'rgba(0,0,0,0.85)';
    toast.style.color = '#fff';
    toast.style.padding = '12px 24px';
    toast.style.borderRadius = '6px';
    toast.style.fontSize = '16px';
    toast.style.zIndex = '9999';
    toast.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 0.3s';
    document.body.appendChild(toast);
    setTimeout(() => { toast.style.opacity = '1'; }, 10);
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => { document.body.removeChild(toast); }, 300);
    }, 2500);
  }

  getLangText(key) {
    const lang = (window.projectConfig && window.projectConfig.lang) || 'cs';
    const texts = {
      cs: {
        success: 'Adresa byla zkopírována do schránky.',
        fail: 'Nepodařilo se zkopírovat adresu do schránky.',
      },
      sk: {
        success: 'Adresa bola skopírovaná do schránky.',
        fail: 'Nepodarilo sa skopírovať adresu do schránky.',
      },
    };
    return (texts[lang] && texts[lang][key]) || texts.cs[key];
  }

  handleLinkClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const url = window.location.href;
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(url)
        .then(() => {
          this.showToast(this.getLangText('success'));
        })
        .catch(() => {
          this.fallbackCopy(url);
        });
    } else {
      this.fallbackCopy(url);
    }
  };

  fallbackCopy(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'absolute';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (err) {
      copied = false;
    }
    document.body.removeChild(textArea);
    if (copied) {
      this.showToast(this.getLangText('success'));
    } else {
      this.showToast(this.getLangText('fail'));
    }
  }

  willUnMount() {
    this.element.removeEventListener('click', this.handleLinkClick);
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CopyToClipboard.js